import { render, staticRenderFns } from "./addMessageTemple.vue?vue&type=template&id=39c24c69&scoped=true&"
import script from "./addMessageTemple.vue?vue&type=script&lang=js&"
export * from "./addMessageTemple.vue?vue&type=script&lang=js&"
import style0 from "./addMessageTemple.vue?vue&type=style&index=0&id=39c24c69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c24c69",
  null
  
)

export default component.exports